import React from 'react';
import LoadingSpinner from 'src/components/loading/spinner';
import { useGlobalContext } from 'src/context/global/use-global-context';
import { twMerge } from 'tailwind-merge';

import SignIn from '../auth/sign-in';

interface IProps {
  className?: string;
  children: React.ReactNode;
}

export default function Layout({ className, children }: IProps) {
  const { user, globalLoading } = useGlobalContext();

  if (globalLoading)
    return (
      <div
        data-testid="loading-spinner-container"
        className="flex h-screen w-full items-center justify-center"
      >
        <LoadingSpinner />
      </div>
    );

  return (
    <main
      className={twMerge([
        'flex h-screen w-full flex-col overflow-y-auto',
        className,
      ])}
    >
      {user ? (
        children
      ) : (
        <div
          data-testid="sign-in-container"
          className="flex h-full w-full items-center justify-center"
        >
          <SignIn />
        </div>
      )}
    </main>
  );
}
